/**
 * Wrapper around common snack options
 * @param snackFunction function that displays the snack message
 * @param variant type of message
 */
export const showSnack = (
	snackFunction: (message: React.ReactNode, options?: object) => any,
	message: string,
	variant: "success" | "error" = "success",
) => {
	snackFunction(message, {
		variant: variant,
		autoHideDuration: 3000,
		anchorOrigin: { horizontal: "center", vertical: "top" },
	});
};
